import { render, staticRenderFns } from "./OracleSyncOrderStatusSuccess.vue?vue&type=template&id=0b8ad73c&scoped=true"
import script from "./OracleSyncOrderStatusSuccess.vue?vue&type=script&lang=js"
export * from "./OracleSyncOrderStatusSuccess.vue?vue&type=script&lang=js"
import style0 from "./OracleSyncOrderStatusSuccess.vue?vue&type=style&index=0&id=0b8ad73c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8ad73c",
  null
  
)

export default component.exports